import { DestinationType } from 'shared/types/destination';
import { getDestinationLabel } from 'shared/utils/destination';

export const SEARCH_FILTER_NAME = 'searchFilter';
export const SELECT_FILTER_NAME = 'selectFilter';

export const SELECT_TYPE_OPTIONS = Object.values(DestinationType).map((destinationType) => {
  const key = destinationType.toUpperCase();

  return {
    name: key,
    label: getDestinationLabel(key as DestinationType),
  };
});
